/**
 * @generated SignedSource<<d040da41f93d8f70c299e7b937a384f3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type hooksAdvertisementCampaignConfigQuery$variables = {
  id?: string | null | undefined;
};
export type hooksAdvertisementCampaignConfigQuery$data = {
  readonly appConfig: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
};
export type hooksAdvertisementCampaignConfigQuery = {
  response: hooksAdvertisementCampaignConfigQuery$data;
  variables: hooksAdvertisementCampaignConfigQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "entityId",
            "variableName": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "filter"
      }
    ],
    "concreteType": "AppConfigs",
    "kind": "LinkedField",
    "name": "appConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "json",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "hooksAdvertisementCampaignConfigQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "hooksAdvertisementCampaignConfigQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b75b2ab9dedf91d50331e0ed762ca866",
    "id": null,
    "metadata": {},
    "name": "hooksAdvertisementCampaignConfigQuery",
    "operationKind": "query",
    "text": "query hooksAdvertisementCampaignConfigQuery(\n  $id: String\n) {\n  appConfig(filter: {entityId: $id}) {\n    json\n  }\n}\n"
  }
};
})();

(node as any).hash = "4daf479e714365c6354a579309413751";

export default node;
